import { apiClient } from '@/shared/api';

import { getProductOneDataProps, type Product } from '../config';

export async function getProductOneData(
  props: getProductOneDataProps,
): Promise<Product> {
  const { slug } = props;
  return await apiClient(`product-one/${slug}`);
}
